import { render } from "./header.vue?vue&type=template&id=167b6394&ts=true"
import script from "./header.vue?vue&type=script&lang=ts"
export * from "./header.vue?vue&type=script&lang=ts"

import "./header.vue?vue&type=style&index=0&id=167b6394&lang=scss"

import exportComponent from "/root/workspace/sso-webclient_Xaij/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__